import applyDirective from '../../plugins/vessel/helpers/directive'
import { isNumber, isString, isArray } from 'vessel/utils'

function styleOptions(value) {
  if (value) {
    return { position: 'sticky', pinTop: true }
  } else {
    return { position: 'static', pinTop: false }
  }
}

function normalizeValue(screen, value) {
  let options = {}
  let values  = {}

  screen = screen || 'all'
  values[screen] = value

  Object.entries(values).forEach(([itemScreen, itemValue]) => {
    options[itemScreen] = styleOptions(itemValue)
  })

  return options
}

function findStickyParent(el) {
  const parent = el.parentElement

  if (parent.classList.contains('layout-header')) {
    return parent
  } else {
    return el
  }
}

function parseOffset(value) {
  let offset = 0

  if (isString(value)) {
    offset = value.endsWith('em') ? (parseInt(value) * 16) : parseInt(value)
  } else if (isNumber(value)) {
    offset = value
  }

  return offset
}

function applyOffset(element, offset, height) {
  const elHeight = height || element.offsetHeight

  if (window != 'undefined' && (offset + elHeight) > window.innerHeight) {
    element.style.top = `${window.innerHeight - elHeight - 16}px`
  } else {
    element.style.top = `${offset}px`
  }
}

function emitEvent(eventName, el, vnode, entry) {
  const instance = vnode.componentInstance
  const observer = el.stickyObserver

  if (instance) {
    instance.$emit(eventName, entry, observer)
  } else {
    const event = new CustomEvent(eventName, { detail: [entry, observer] })
    el.dispatchEvent(event)
  }
}

function addIntersectionObserver(el, { modifiers }, vnode) {
  if (!modifiers.observe) return

  el.stickyObserver = new IntersectionObserver(entries => {
    const entry = entries[0]

    if (entry.intersectionRatio === 0) {
      emitEvent('stick', el, vnode, entry)
    } else if (entry.intersectionRatio === 1) {
      emitEvent('unstick', el, vnode, entry)
    }

  }, { threshold: [0, 1] })

  el.stickySentinel = document.createElement('div')
}

function removeIntersectionObserver(el) {
  unmountSentinel(el)

  if (el.stickyObserver) {
    el.stickyObserver.disconnect()
  }
}

function addResizeObserver(el, { value, arg }) {
  const offset = parseOffset(value)
  if (arg !== 'smart') return

  el.stickyWindowObserver = (data) => {
    const element = findStickyParent(el)
    const height  = isArray(data) ? data[0].contentRect.height : null

    applyOffset(element, offset, height)
  }

  el.stickyResizeObserver = new ResizeObserver(el.stickyWindowObserver)
  window.addEventListener('resize', el.stickyWindowObserver, false)
}

function removeResizeObserver(el) {
  if (el.stickyResizeObserver) {
    el.stickyResizeObserver.disconnect()
    window.removeEventListener('resize', el.stickyWindowObserver)
  }
}

function addObservers(el, options, vnode) {
  addResizeObserver(el, options)
  addIntersectionObserver(el, options, vnode)
}

function removeObservers(el, options) {
  removeResizeObserver(el, options)
  removeIntersectionObserver(el, options)
}

function mountSentinel(el) {
  if (!el.stickyMounted) {
    const element = findStickyParent(el)
    const parent  = element.parentElement

    parent.insertBefore(el.stickySentinel, parent.firstChild)
    el.stickyMounted = true
  }
}

function unmountSentinel(el) {
  if (el.stickyMounted) {
    el.stickySentinel.remove()
    el.stickyMounted = false
  }
}

function updateDirective(el, { arg, value }) {
  if (value == null) {
    return unmountSentinel(el)
  }

  const offset  = parseOffset(value)
  const element = findStickyParent(el)
  const options = normalizeValue(arg, value)

  element.style.top = `${offset}px`

  if (el.stickySentinel) {
    el.stickySentinel.style.width = '100%'

    if (offset > 0) {
      el.stickySentinel.style.position = 'relative'
      el.stickySentinel.style.top = `-${offset}px`
    } else {
      el.stickySentinel.style.position = 'absolute'
    }

    mountSentinel(el)
  }

  if (el.stickyResizeObserver) {
    applyOffset(element, offset)
  }

  applyDirective('sticky', element, options)
}

function insertDirective(el, { arg, value }) {
  updateDirective(el, { arg, value })

  if (el.stickySentinel) {
    el.stickyObserver.observe(el.stickySentinel)
  }

  if (el.stickyResizeObserver) {
    const element = findStickyParent(el)
    el.stickyResizeObserver.observe(element)
  }
}

const Plugin = {
  install(Vue) {
    Vue.directive('sticky', {
      bind: addObservers,
      inserted: insertDirective,
      update: updateDirective,
      unbind: removeObservers
    })
  }
}

export default Plugin
